import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import TextChartTitle from '@components/text/TextChartTitle'
import { Progress, Table } from '@mantine/core'
import TableHeaderColumn from '@components/table/template/TableHeaderColumn'
import { IResponseOptProjectBudgetRanking } from '@interfaces/api/IDashboard'
import { Money } from '@utils/utils'

const ProjectBudgetRanking = ({ title, data }: { title: string; data: IResponseOptProjectBudgetRanking }) => {
  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Table pos={'relative'}>
        <thead>
          <tr>
            <TableHeaderColumn label={'อันดับ'} width={'5%'} />
            <TableHeaderColumn label={'รหัสโครงการ'} width={'10%'} />
            <TableHeaderColumn label={'ชื่อโครงการ'} width={'40%'} />
            <TableHeaderColumn label={'งบประมาณ'} width={'10%'} />
            <TableHeaderColumn label={''} width={'400px'} />
          </tr>
        </thead>
        <tbody>
          {data.map((p) => (
            <tr key={p.project_code}>
              <td>{p.rank_no}</td>
              <td>{p.project_code}</td>
              <td>{p.project_name}</td>
              <td>{Money(p.project_budget)}</td>
              <td>
                <Progress
                  w="100%"
                  size="xl"
                  sections={[
                    {
                      value: parseFloat(p.project_budget) / (parseFloat(data[0].project_budget) / 100),
                      color: 'blue',
                    },
                  ]}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ChartFlexSection>
  )
}

export default ProjectBudgetRanking
